import { Box } from '@mui/material';
import React from 'react';
import CrossDeviceLogin from '../../../components/CrossDeviceLogin';
import QrPairingGate from '../../../components/QrPairingGate';
import { StyledTypography } from '../../../components/styles/styles';

const CrossDeviceTab: React.FC = () => (
  <Box>
    <StyledTypography sx={{ mb: 3 }}>
      Generate a QR code to log into this account on your mobile device, or scan a code from another
      device.
    </StyledTypography>
    <QrPairingGate>
      <CrossDeviceLogin />
    </QrPairingGate>
  </Box>
);

export default CrossDeviceTab;
